import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  pageNo: 1,
  pageSize: 10,
};

export const hospitalReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("GET_ALL_HOSPITALS_LIST_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_HOSPITALS_LIST_SUCCESS", (state, action) => {
      state.loading = false;
      state.hospitalsList = action.payload.hospitalsList;
      state.hospitalsCount = action.payload.hospitalsCount;
    })
    .addCase("GET_ALL_HOSPITALS_LIST_FAIL", (state, action) => {
      state.loading = false;
    });
});
